import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { ErrorDisplay } from './components/Error/Error'
import '@/styles/_globals.css'
import '@/styles/_hljs.css'

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }
  render() {
    if (this.state.hasError) {
      return <ErrorDisplay error={this.state.error} />
    }

    return this.props.children
  }
}

// This fixes the flash of dark/light content on reload
const initialThemeStyle = document.createElement('style')
initialThemeStyle.innerHTML = `
  html, body {
    background-color: #FFFFFF;
  }

  /* Set default light theme variables */
  :root {
    --ds-surface: #ffffff;
    --ds-surface-raised: #f4f5f7;
    --ds-surface-sunken: #f4f5f7;
    --ds-border: #dfe1e6;
    --ds-text: #172b4d;
    --ds-text-subtle: #6b778c;
    --ds-text-inverse: #ffffff;
  }
  
  @media (prefers-color-scheme: dark) {
    html, body {
      background-color: #1D2125;
      color: #E6EDFC;
    }

    /* Set dark theme variables */
    :root {
      --ds-surface: #1D2125;
      --ds-surface-raised: #262B31;
      --ds-surface-sunken: #161A1D;
      --ds-border: rgba(255, 255, 255, 0.3);
      --ds-text: #E6EDFC;
      --ds-text-subtle: #8C9BAB;
      --ds-text-inverse: #1D2125;
    }
  }
`
document.head.appendChild(initialThemeStyle)

ReactDOM.createRoot(document.getElementById('root') as Element).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
)
